<template>
    <div>
        <div
            id="page-container"
            class="h-screen overflow-auto bg-neutral-100 dark:bg-gray-800">
            <HeaderFrontend class="bg-white" />
            <ImpersonateBanner />
            <SystemBanner />
            <BaseSlideOver
                :header-color="'primary'"
                :title="$t(slideOverStore.title)"
                :description="$t(slideOverStore.description)"
                :model-value="slideOverStore.isSlideOverOpen"
                @update:modelValue="slideOverStore.setSlideOverOpen($event)">
                <Component :is="components[slideOverStore.component]" />
            </BaseSlideOver>
            <main class="max-w-7xl mx-auto ">
                <!-- Your content -->
                <div
                    v-if="underConstruction"
                    class="px-4 sm:px-6 lg:px-8 py-2 sm:py-5 md:py-10 ">
                    <ComingSoonPage
                        hide-dashboard-link />
                </div>
                <div v-else>
                    <CmsFrontendAlert />
                    <div class="px-4 sm:px-6 lg:px-8 py-2 sm:py-5 md:py-10 ">
                        <slot />
                    </div>
                </div>

                <ScrollBackToTopButton />
            </main>
            <FooterFrontend />
        </div>
    </div>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import FundingProgramsSelection from "@/components/global/FundingPrograms/FundingProgramsSelection"
import ProcessAddDocuments from "@/components/global/Processes/ProcessAddDocuments"
import ProcessCopySettings from "@/components/global/Processes/ProcessCopySettings"
import HeaderFrontend from "@/components/layouts/HeaderFrontend"
import AuthWrapper from "@/components/pages/auth/AuthWrapper.vue"
import NewStatisticProcess from "@/components/pages/statisticProcesses/NewStatisticProcess"
import {useNotification} from "@/composables/useNotification"
import {useAuthStore} from "@/store/auth"
import {useCmsNavItemsStore} from "@/store/cmsNavItems"
import {useSlideOverStore} from "@/store/slideOver"
import {useWebsocketStore} from "@/store/websockets"
import {$larafetch} from "@/utils/$larafetch"

const authStore = useAuthStore()
const slideOverStore = useSlideOverStore()
const route = useRoute()
const notification = useNotification()
const app = useNuxtApp()
const {t: $t} = useI18n()

const sportbizzRefreshInterval = ref(null)

const components = {
    FundingProgramsSelection,
    NewStatisticProcess,
    AuthWrapper,
    ProcessCopySettings,
    ProcessAddDocuments,
}

const underConstruction = computed(() => useRuntimeConfig()?.public?.underConstruction)

onMounted(() => {
    if (authStore.userData) {
        useWebsocketStore().init()
    }

    useCmsNavItemsStore().fetchCmsNavItems()

    if (route.query?.resetPassword === "true") {
        slideOverStore.setSlideOverOpen(true)
        slideOverStore.setTitle('auth.resetPassword')
        slideOverStore.setDescription('')
        slideOverStore.setComponent('AuthWrapper')
        slideOverStore.setContext(null)
    }

    if (route.query?.verified == 1) {
        notification.success($t('auth.emailVerified'))
    }

    // sportbizz refresh
    if (authStore.userData && authStore.userData.is_sportbizz === true) {
        sportbizzRefreshInterval.value = setInterval(function () {
            $larafetch(app.$apiRoute('sportbizz.refresh'), {
                method: 'GET',
            }).then(response => {
            }).catch(e => {
                notification.error(app.$i18n.t('sportbizz.refresh.error'), e.data.message)

                if (e.response.status === 401) {
                    authStore.resetAuthData()
                    navigateTo({
                        path: '/'
                    })
                }

                console.error(e)
            })
        }, 60000)
    }
})

watch(() => authStore.isAuthenticated, () => {
    if (!authStore.isAuthenticated && sportbizzRefreshInterval.value) {
        clearInterval(sportbizzRefreshInterval.value)
    }
})

onBeforeUnmount(() => {
    if (sportbizzRefreshInterval.value) {
        clearInterval(sportbizzRefreshInterval.value)
    }
})

useHead({
    bodyAttrs: {
        class: 'h-full bg-gray-50'
    },
    htmlAttrs: {
        class: 'h-full'
    }
})
</script>
